export default {
  apiKey: "AIzaSyCG0_nLD9g5Rvsk3HsVGL-ya3iIYCmwgqU",
  authDomain: "edemdancemain.firebaseapp.com",
  databaseURL: "https://edemdancemain.firebaseio.com",
  projectId: "edemdancemain",
  storageBucket: "edemdancemain.appspot.com",
  messagingSenderId: "29494425334",
  appId: "1:29494425334:web:223db61231e5fab0069ed7",
  measurementId: "G-93PKC0QFVY"
};